import React from "react";
import { Helmet } from "react-helmet-async";

import ContactHero from "../components/contact/ContactHero";
import GlobalCta from "../components/global/GlobalCta";
import FujairahTextImage from "../components/truck-rental-fujairah/FujairahTextImage";
import FujairahTextSection from "../components/truck-rental-fujairah/FujairahTextSection";
import FujairahIndustries from "../components/truck-rental-fujairah/FujairahIndustries";
import FujairahAreas from "../components/truck-rental-fujairah/FujairahAreas";
import FujairahPricing from "../components/truck-rental-fujairah/FujairahPricing";
import FujairahFaq from "../components/truck-rental-fujairah/FujairahFaq";

import { truckRentalFujairahSections } from "../components/truck-rental-fujairah/truckRentalFujairahSections";
import "../components/truck-rental-fujairah/truck-rental-fujairah.css";

const TruckRentalInFujairah = () => {
  const renderSection = (section, index) => {
    switch (section.type) {
      case "ft-hero":
        return (
          <ContactHero
            key={index}
            variant="fujairah"
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "ft-text-image":
        return (
          <FujairahTextImage
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
            image={section.image}
            imageAlt={section.imageAlt}
            reverse={section.reverse}
            altBg={section.altBg}
          />
        );

      case "ft-text-only":
        return (
          <FujairahTextSection
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      case "ft-industries":
        return (
          <FujairahIndustries
            key={index}
            title={section.title}
            description={section.description}
            industries={section.industries}
          />
        );

      case "ft-areas":
        return (
          <FujairahAreas
            key={index}
            title={section.title}
            description={section.description}
            areas={section.areas}
          />
        );

      case "ft-pricing":
        return (
          <FujairahPricing
            key={index}
            title={section.title}
            description={section.description}
            rows={section.rows}
            notes={section.notes}
            footnote={section.footnote}
          />
        );

      case "ft-faq":
        return (
          <FujairahFaq
            key={index}
            title={section.title}
            faqs={section.faqs}
          />
        );

      case "cta":
        return (
          <GlobalCta
            key={index}
            title={section.title}
            paragraphs={section.paragraphs}
          />
        );

      default:
        return null;
    }
  };

  return (
    <>
      <Helmet>
        <title>Temperature Controlled Truck Rental in Fujairah From AED 550/Day | Chiller Fleet Transport</title>
        <meta name="description" content="Chiller, freezer and multi-temperature refrigerated trucks rental in Fujairah — 3 to 15 tons for port, free zone and East Coast cold chain operations. Get a vehicle now." />
        <link rel="canonical" href="https://chillerfleet.com/truck-rental-in-fujairah" />
        <meta property="og:title" content="Temperature Controlled Truck Rental in Fujairah From AED 550/Day | Chiller Fleet Transport" />
        <meta property="og:description" content="Chiller, freezer and multi-temperature refrigerated trucks rental in Fujairah — 3 to 15 tons for port, free zone and East Coast cold chain operations. Get a vehicle now." />
        <meta property="og:url" content="https://chillerfleet.com/truck-rental-in-fujairah" />
        <meta name="twitter:title" content="Temperature Controlled Truck Rental in Fujairah From AED 550/Day | Chiller Fleet Transport" />
        <meta name="twitter:description" content="Chiller, freezer and multi-temperature refrigerated trucks rental in Fujairah — 3 to 15 tons for port, free zone and East Coast cold chain operations. Get a vehicle now." />
      </Helmet>

      {truckRentalFujairahSections.map(renderSection)}
    </>
  );
};

export default TruckRentalInFujairah;
